module.exports = __webpack_public_path__ + "static/media/elementos.1361359e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/elementos.png
// module id = 305
// module chunks = 0